import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Dialog,
  CircularProgress,
  TextField,
  Typography,
  Stepper,
  Step,
  StepLabel,
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Paper,
  ButtonGroup,
} from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import { VariableSizeList } from "react-window";
import {
  Cancel,
  Close,
  NavigateBefore,
  NavigateNext,
} from "@material-ui/icons";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import Carousel from "react-elastic-carousel";
import { useConfirm } from "material-ui-confirm";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { useEffect, useState } from "react";
import MultiFileUpload from "./MultiFileUpload";
import { currencies } from "../api/countries";
import { useInput } from "../utils/useInputHook";
import { fetchTraitsByCategory } from "../api/categories";
import { addActivity, updateActivity } from "../api/activities";
import { useAlert } from "react-alert";
import WidgetComponent from "./WidgetComponent";
import AddSlotComponent from "./AddSlotComponent";
import SlotCard from "./SlotCard";
import React from "react";
import { getDefaultValueByWidgetType } from "./InputWidgets";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import ListSubheader from "@material-ui/core/ListSubheader";
import { useTheme } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Tooltip from "@material-ui/core/Tooltip";
import RequestCategory from "../components/RequestCategory";
import formatLocation from "../utils/formatLocation";
import config from "../config";
import { countries, countryToFlag } from "../api/countries";
import { States}  from "../api/states";
import PlacePicker from "./PlacePicker";
import { Fragment } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ImageGrid from "./ImageGrid";

import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { getAssociatedBranches } from "../api/activities";

const LISTBOX_PADDING = 8; // px

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1, 0),
    },
  },
  formControl: {
    width: "30%",
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  heading: {
    margin: theme.spacing(1, 0, 2, 0),
  },
  previewWrapper: {
    position: "relative",
    "&  .MuiIconButton-root": {
      position: "absolute",
      top: "0",
      right: "0",
    },
  },
  preview: {
    width: 100,
    height: 100,
    borderRadius: 4,
    margin: theme.spacing(0.5),
  },
  uploadSelect: {
    margin: theme.spacing(0.5),
    width: 100,
    height: 100,
  },
  description: {
    "& .MuiInputBase-root": {
      padding: "16.5px 14px",
    },
  },
  chipGroup: {
    border: "1px solid #ccc",
    padding: theme.spacing(1, 0),
    minHeight: 100,
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
}));

function renderRow(props) {
  const { data, index, style } = props;
  return React.cloneElement(data[index], {
    style: {
      ...style,
      top: style.top + LISTBOX_PADDING,
    },
  });
}

const OuterElementContext = React.createContext({});

const OuterElementType = React.forwardRef((props, ref) => {
  const outerProps = React.useContext(OuterElementContext);
  return <div ref={ref} {...props} {...outerProps} />;
});

function useResetCache(data) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    if (ref.current != null) {
      ref.current.resetAfterIndex(0, true);
    }
  }, [data]);
  return ref;
}

// Adapter for react-window
const ListboxComponent = React.forwardRef(function ListboxComponent(
  props,
  ref
) {
  const { children, ...other } = props;
  const itemData = React.Children.toArray(children);
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"), { noSsr: true });
  const itemCount = itemData.length;
  const itemSize = smUp ? 36 : 48;

  const getChildSize = (child) => {
    if (React.isValidElement(child) && child.type === ListSubheader) {
      return 48;
    }

    return itemSize;
  };

  const getHeight = () => {
    if (itemCount > 8) {
      return 8 * itemSize;
    }
    return itemData.map(getChildSize).reduce((a, b) => a + b, 0);
  };

  const gridRef = useResetCache(itemCount);

  return (
    <div ref={ref}>
      <OuterElementContext.Provider value={other}>
        <VariableSizeList
          itemData={itemData}
          height={getHeight() + 2 * LISTBOX_PADDING}
          width="100%"
          ref={gridRef}
          outerElementType={OuterElementType}
          innerElementType="ul"
          itemSize={(index) => getChildSize(itemData[index])}
          overscanCount={5}
          itemCount={itemCount}
        >
          {renderRow}
        </VariableSizeList>
      </OuterElementContext.Provider>
    </div>
  );
});

const merge_traits = (new_traits) => (old_traits) => {
  let traits = new_traits.map((traitGroup) => {
    traitGroup.traits = traitGroup.traits.map((c) => ({
      ...c,
      currentValue: getDefaultValueByWidgetType(c.widget_type),
    }));
    return traitGroup;
  });
  for (let i in traits) {
    let trait_group = traits[i];
    for (let j in old_traits) {
      let old_trait_group = old_traits[j];
      if (
        (old_trait_group?.trait_group === trait_group?.trait_group ||
          old_trait_group?.trait_group_id === trait_group?.trait_group_id) &&
        old_trait_group?.is_filled === true
      ) {
        traits[i] = old_trait_group;
        break;
      }
    }
  }
  return traits;
};

const filter = createFilterOptions();
export default function AddActivityComponent({
  providerId,
  providerCategory,
  activity,
  user,
  providerCategoryList,
  categoryList,
  onUpdate,
  onCancel,
  providerCategoryTree,
  activityCategoryTree,
}) {
  const [templateBranches, setTemplateBranches] = useState([]);
  const isEditForm = !!activity._id;
  const showStepFour = isEditForm && !activity.branch_id;
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [updatedProperties, setUpatedProperties] = useState({});
  const [updatedTraits, setUpdatedTraits] = useState({});

  useEffect(() => {
    if (showStepFour) {
      getAssociatedBranches(activity._id, user.token).then((response) => {
        setTemplateBranches(response);
      });
    }
  }, []);

  // add api call for getting branches associated with the template

  const flag_options_encoding = {
    one_of_a_kind: "One of a kind",
    event: "Event",
    local: "Local",
    indoor_only: "Indoor Only",
    outdoor_only: "Outdoor Only",
    men_only: "Men Only",
    women_only: "Women Only",
    kids_only: "Kids Only",
  };

  const flag_options_decoding = {
    "One of a kind": "one_of_a_kind",
    Event: "event",
    Local: "local",
    "Indoor Only": "indoor_only",
    "Outdoor Only": "outdoor_only",
    "Men Only": "men_only",
    "Women Only": "women_only",
    "Kids Only": "kids_only",
  };

  const flag_options = [
    "One of a kind",
    "Event",
    "Local",
    "Indoor Only",
    "Outdoor Only",
    "Men Only",
    "Women Only",
    "Kids Only",
  ];

  const encodeFlags = (flags_en) => {
    let enFlags = flags_en.map((flag) => flag_options_encoding[flag]);
    // console.log(flags_en,enFlags)
    return enFlags;
  };

  const decodeFlags = (flags_de) => {
    let deFlags = flags_de.map((flag) => flag_options_decoding[flag]);
    return deFlags;
  };

  // console.log(activity?.info?.category?.id)
  const classes = useStyles();
  const alert = useAlert();
  const confirm = useConfirm();
  const [loading, setLoading] = useState(false);
  // we can decide if the form is create or edit by checking `id` field

  const { value: name, bind: bindName } = useInput(activity?.info?.name || "");
  const { value: description, bind: bindDescription } = useInput(
    activity?.info?.description || ""
  );
  const [radioValue, setRadioValue] = React.useState('');
  const [currency, setCurrency] = useState(
    activity?.info?.cost?.currency || "GBP"
  );
  const { value: cost, bind: bindCost } = useInput(activity?.info?.cost?.cost);
  const [expectedDurationUnit, setDurationUnit] = useState(
    activity?.info?.expected_duration?.unit || ""
  );
  const { value: expectedDuration, bind: bindExpectedDuration } = useInput(
    activity?.info?.expected_duration?.duration
  );
  const { value: maxPeople, bind: bindMaxPeople } = useInput(
    activity?.info?.max_capacity
  );
  const [slots, setSlots] = useState(activity?.time_slots || []);
  const [slotModalActive, setSlotModalActive] = useState(false);
  const [selectedSlot, setSelectedSlot] = useState({});
  const [selectedSlotIndex, setSelectedSlotIndex] = useState(-1);
  const [currentStep, setCurrentStep] = useState(0);
  const [traits, setTraits] = useState([]);
  const [is_visit, setVisit] = useState(activity?.is_visit_flag || false);
  const [visiting_hours, setVisitingHours] = useState(
    activity?.is_visiting_opening_hours_flag || false
  );
  const [isgenericimages, setGenericImageCheck] = useState(
    activity?.generic_images_flag || false
  );
  const [isResetBranchData, setResetBranchData] = useState(false);

  const [imageData, setImageData] = useState(
    activity?.images?.map((i) => ({ ...i, type: "uploaded" })) ?? []
  );
  const [removedImages, setRemovedImages] = useState([]);
  const currentCategory = activity?.is_visit_flag
    ? providerCategoryList.find(
        (category) => category._id === activity?.info?.category?.id
      )
    : categoryList.find(
        (category) => category._id === activity?.info?.category?.id
      ) || null;
  const [category, setCategory] = useState(currentCategory);
  const [flags, setFlags] = useState(
    activity?.info?.flags ? encodeFlags(activity?.info?.flags) : []
  );
  const { value: notes, bind: bindNotes } = useInput(
    activity?.info?.notes || ""
  );
  const { value: trait_notes, bind: bindTraitNotes } = useInput(
    activity?.trait_notes || ""
  );
  // console.log("provider category - ", providerCategoryList.find(category => category._id === providerCategory?.id))
  const [requestDialogActive, setRequestDialogActive] = useState(false);
  const [dialogValue, setDialogValue] = useState({
    parent: "",
    name: "",
    description: "",
  });

  const [location_flag, setLocationFlag] = useState(
    activity?.location_flag || false
  );
  const {
    value: addressLine1,
    bind: bindAddressLine1,
    setValue: setAddressLine1,
  } = useInput(activity?.address?.address_line_1 || "");
  const {
    value: street,
    bind: bindStreet,
    setValue: setStreet,
  } = useInput(activity?.address?.street || "");
  const {
    value: landmark,
    bind: bindLandmark,
    setValue: setLandmark,
  } = useInput(activity?.address?.landmark || "");
  const {
    value: area,
    bind: bindArea,
    setValue: setArea,
  } = useInput(activity?.address?.area || "");
  const {
    value: city,
    bind: bindCity,
    setValue: setCity,
  } = useInput(activity?.address?.city || "");
  const [state, setStateValue] = useState(!!activity?.address?.state  ? { name: activity?.address?.state  } : {name: ''});
  const [country, setCountry] = useState(
    !!activity?.address?.country
      ? { label: activity?.address?.country }
      : { label: "" }
  );
  const { value: zipCode, bind: bindZipCode } = useInput(
    activity?.address?.zip_code || ""
  );
  const [location, setLocation] = useState(
    formatLocation(activity?.address?.location)
  );
  const [mapLoading, setMapLoading] = useState(false);

  const [expanded, setExpanded] = useState(false);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" htmlColor="#ff3f71" />;

  const filter = createFilterOptions();

  const handleExpand = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? true : false);
  };

  const handleCategoryRequest = (name) => {
    setDialogValue({ ...dialogValue, name });
    setRequestDialogActive(true);
  };

  const handleRequestFormClose = () => {
    setRequestDialogActive(false);
    setDialogValue({ parent: "", name: "", description: "" });
  };

  const onCategoryRequest = (data) => {
    setCategory({ _id: data.parent, name: data.parent_name || data.name });
    handleRequestFormClose();
  };
  const setFilterStates = (label) => {
    const country =  countries.filter((d) => d.label == label);
    const filterStateData = States.filter((d) => (d.country_code === country[0].code));
    return filterStateData;
  };
  const [filterState, setFilterState] = useState(activity?.info?.address?.country ? setFilterStates(activity?.info?.address?.country) : setFilterStates("United Kingdom"));

  const onCountryChange = (value) => {
    setCountry(value);
    filterStateFun(value.code);
    setStateValue({name:''});
  };
  const handleRadioChange = (data) => {
    setRadioValue(data.target.value);
    if(data.target.value ==='copyBelow'){
      setResetBranchData(false)
    }else{
      setResetBranchData(true)
    }
  };

  const onChangeLocationFlag = (value) => {
    if(value){
      setStateValue({name:"City of London"});
      setCountry({ label: "United Kingdom" })
    }else{
      setStateValue({name:''});
      setCountry({ label: '' })
    }
  }

  const filterStateFun = (countryCode) => {
    const filterStateData = States.filter((d) => 
    (d.country_code === countryCode));
    setFilterState(filterStateData);
  };
  const changes = {
    name: {
      show: name !== activity?.info?.name,
      label: "Name",
      value: name,
    },
    description: {
      show: description !== activity?.info?.description,
      label: "Description",
      value: description,
    },
    currency: {
      show: currency !== activity?.info?.cost?.currency,
      label: "Currency",
      value: currency,
    },
    cost: {
      show: cost !== activity?.info?.cost?.cost,
      label: "Cost",
      value: cost,
    },
    is_visit_flag: {
      show: is_visit !== activity?.is_visit_flag,
      label: "Activity type",
      value: is_visit,
    },
    is_visiting_opening_hours_flag: {
      show: visiting_hours !== activity?.is_visiting_opening_hours_flag,
      label: "Visiting hours",
      value: visiting_hours,
    },
    max_capacity: {
      show: maxPeople !== activity?.info?.max_capacity,
      label: "Maximum capacity",
      value: maxPeople,
    },
    duration: {
      show: expectedDuration !== activity?.info?.expected_duration?.duration,
      label: "Expected Duration",
      value: expectedDuration,
    },
    unit: {
      show: expectedDurationUnit !== activity?.info?.expected_duration?.unit,
      label: "Expected Duration unit",
      value: expectedDurationUnit,
    },
    category: {
      show: category?.name !== currentCategory?.name,
      label: "Category name",
      value: {id: category?._id, name: category?.name},
    },
    flags: {
      show:
        JSON.stringify(decodeFlags(flags)) !==
        JSON.stringify(activity?.info?.flags || []),
      label: "Flags",
      value: decodeFlags(flags),
    },
    time_slots: {
      show:
        JSON.stringify(slots) !== JSON.stringify(activity?.time_slots || []),
      label: "Time slots",
      value: slots,
    },
    images: {
      show:(removedImages?.length !== 0 || imageData?.length !== activity?.images?.length),
      label: "Images",
      value: imageData,
    },
    generic_images_flag: {
      show: (isgenericimages !== activity?.generic_images_flag && (( isgenericimages === true && typeof(activity?.generic_images_flag) === 'undefined')
      || typeof(activity?.generic_images_flag) !== 'undefined' )) ,

      label: "Generic Image Flag",
      value: isgenericimages,
    },
    notes: {
      show:
        JSON.stringify(notes || []) !==
        JSON.stringify(activity?.info?.notes || []),
      label: "Notes",
      value: notes,
    },
    trait_notes: {
      show:
        JSON.stringify(trait_notes || []) !==
        JSON.stringify(activity?.trait_notes || []),
      label: "Trait notes",
      value: trait_notes,
    },
    location_flag: {
      show: location_flag !== activity?.location_flag,
      label: "Location flag",
      value: location_flag,
    },
    address_line_1: {
      show: addressLine1 !== (activity?.address?.address_line_1 || ""),
      label: "Address line 1",
      value: addressLine1,
    },
    street: {
      show: street !== (activity?.address?.street || ""),
      label: "Street",
      value: street,
    },
    landmark: {
      show: landmark !== (activity?.address?.landmark || ""),
      label: "Lamdmark",
      value: landmark,
    },
    area: {
      show: area !== (activity?.address?.area || ""),
      label: "Area",
      value: area,
    },
    city: {
      show: city !== (activity?.address?.city || ""),
      label: "City",
      value: city,
    },
    state: {
      show: state.name !== (activity?.address?.state || ""),
      label: "State",
      value: state.name,
    },
    country: {
      show: country.label !== (activity?.address?.country || ""),
      label: "Country",
      value: country.label,
    },
    zip_code: {
      show: zipCode !== (activity?.address?.zip_code || ""),
      label: "Postcode",
      value: zipCode,
    },
    lat: {
      show: location?.lat !== activity?.address?.location?.coordinates[1],
      label: "Latitude",
      value: location?.lat,
    },
    lng: {
      show: location?.lng !== activity?.address?.location?.coordinates[0],
      label: "Longitude",
      value: location?.lng,
    },
  };

  const currentTraits = traits?.reduce(
    (acc, item) => [
      ...acc,
      ...item.traits.map((traitItem) => ({
        ...traitItem,
        trait_group_id: item.trait_group_id,
      })),
    ],
    []
  );

  const previousTraits = activity.traits?.reduce(
    (acc, item) => [...acc, ...item.traits],
    []
  );

  let traitChanges = [];

  if (previousTraits?.length > 0)
    currentTraits.forEach((item, index) => {
      if (!item?.currentValue) return;
      if (item?.currentValue === previousTraits[index]?.currentValue) return;

      if (typeof item?.currentValue === "object") {
        if (
          JSON.stringify(item?.currentValue) ===
          JSON.stringify(previousTraits[index]?.currentValue || {})
        )
          return;
      }
      traitChanges.push({
        show: true,
        label: item.title,
        trait_group_id: item.trait_group_id,
        trait_name: item.trait_name,
      });
    });

  // ==================================================================

  useEffect(() => {
    // fetch traits -> set them
    console.log("Going ", category);
    if (!!category && category.name !== activity.info?.category?.name) {
      setLoading(true);
      fetchTraitsByCategory(
        category?._id || category?.id,
        is_visit ? "Provider_category" : "Activity_category",
        user.token
      )
        .then((traitGroups) => {
          traitGroups = traitGroups.sort((a, b) =>
            a.priority > b.priority ? 1 : -1
          );
          setTraits(merge_traits(traitGroups));
          // setTraits(traitGroups.map(traitGroup => {
          //     traitGroup.traits = traitGroup.traits
          //         .map(c => ({
          //             ...c,
          //             currentValue: getDefaultValueByWidgetType(c.widget_type)
          //         }));
          //     return traitGroup;
          // }))
        })
        .then(() => setLoading(false));
    } else {
      console.log("Setting existing traits", activity.traits);
      //add the pre step to set colour
      setTraits(activity.traits || []);
    }
  }, [
    user.token,
    category,
    is_visit,
    activity.info?.category?.name,
    activity.traits,
  ]);

  useEffect(() => {
    const delayed = setTimeout(async () => {
      const empty_address = ",,,,,United Kingdom,";
      const combined = [
        addressLine1,
        street,
        area,
        city,
        state?.name || "",
        country?.label || "",
        zipCode,
      ].join(",");
      if (!location_flag && empty_address === combined) return;
      setMapLoading(true);
      console.log("stopped typing, checking location");
      try {
        const defaultAddress = [
          activity?.address?.address_line_1,
          activity?.address?.street,
          activity?.address?.area,
          activity?.address?.city,
          activity?.address?.state,
          activity?.address?.country,
          activity?.address?.zip_code,
        ].join(",");
        if (combined === defaultAddress) {
          console.log(
            "address same => setting to saved location",
            defaultAddress,
            combined
          );
          setLocation(formatLocation(activity?.address?.location));
          return;
        }
        if (combined.length < 5) return;
        console.log(`Fetching new location`, defaultAddress, combined);
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          combined
        )}&key=${config.GOOGLE_MAPS_API_KEY}`;
        const req = await fetch(url);
        const data = await req.json();
        if (data.status === "OK") {
          const location = data.results[0].geometry.location;
          console.log(`Locationfound`, location);
          setLocation(location);
        } else {
          console.log("no data?", data);
          alert.show("Failed to convert address to location");
        }
      } catch (e) {
        console.log(e);
      } finally {
        setMapLoading(false);
      }
    }, 1000);
    return () => clearTimeout(delayed);
  }, [addressLine1, street, area, city, state, country, zipCode, alert]);

  const handleSubmit = async (e) => {
    const newFiles = imageData
      .filter((u) => u.type === "file")
      .map((u) => u.file);
    const data = {
      name,
      description,
      currency,
      cost,
      is_visit,
      visiting_hours,
      max_capacity: maxPeople,
      expected_duration: expectedDuration,
      expected_duration_unit: expectedDurationUnit,
      traits: JSON.stringify(traits),
      category_name: category?.name,
      category_id: category?._id,
      flags: decodeFlags(flags),
      time_slots: JSON.stringify(slots),
      notes,
      trait_notes,
      isgenericimages,
      isResetBranchData,
      images: newFiles,
      removed_images: removedImages,
      imageAttributes: JSON.stringify(
        imageData.map((item, i) => ({ ...item, order: i }))
      ),
      location_flag,
      addressLine1,
      street,
      landmark,
      area,
      city,
      zip_code: zipCode,
      state: state.name,
      country: country.label,
      latitude: location?.lat,
      longitude: location?.lng,
      updatedBranches: JSON.stringify(selectedBranches),
      updatedProperties: JSON.stringify(changes),
      updatedTraits: JSON.stringify(traitChanges),
    };

    // console.log(data)

    try {
      setLoading(true);
      if (isEditForm) {
        const updated = await updateActivity(
          providerId,
          { _id: activity._id, ...data },
          user.token
        );
        onUpdate(updated);
        onCancel();
        return;
      }
      const updated = await addActivity(providerId, data, user.token);
      onUpdate(updated);
      onCancel();
    } catch (e) {
      console.error(e);
      alert.show("Error occoured");
    } finally {
      setLoading(false);
    }
  };

  const preImageRemove = async (i) => {
    try {
      await confirm({
        description: "Are you sure you want to remove this image?",
      });
      console.log("Removing image");
      return handleImageRemove(i);
    } catch (e) {
      return console.log("remove image cancelled");
    }
  };

  const handleImageRemove = (i) => {
    if (imageData[i].type === "uploaded") {
      setRemovedImages((current) => current.concat(imageData[i].editedUri));
    }
    if (imageData.length == 1){
      setGenericImageCheck(false);
    }
    const updatedFiles = [...imageData];
    updatedFiles.splice(i, 1);
    setImageData(updatedFiles);
  };

  const handleImageAdd = (images) => {
    const newImages = images.map((image) => {
      return {
        type: "file",
        editedUri: URL.createObjectURL(image),
        originalUri: URL.createObjectURL(image),
        file: image,
        isChecked: true,
      };
    });
    setImageData((current) => current.concat(newImages));
  };

  const UploadImages = () => {
    return (
      <>
        <Grid item xs={12} key="add-activity-image-header">
          <Typography variant="h6">Images</Typography>
        </Grid>
        <Grid item xs={12}>
            <FormControlLabel
                label="Generic Images"
                control={
                  <Checkbox
                    checked={isgenericimages}
                    disabled={imageData.length < 1}
                    onChange={() => setGenericImageCheck(!isgenericimages)}
                />
                }
              />
        </Grid>
        <Grid item xs={12} key="add-activity-image-wrapper">
          <ImageGrid
            images={imageData}
            setGridData={setImageData}
            preImageRemove={preImageRemove}
          />
          <MultiFileUpload onAdd={handleImageAdd} />
        </Grid>
        { showStepFour && <Grid item xs={12}>
        <Typography variant="caption" display="block" >Note: Images changes hear will not be added in branch activity</Typography>
        </Grid> }
      </>
    );
  };

  const onPrevClick = () => {
    if (currentStep === 2) {
      if (traits.length === 0) {
        setCurrentStep(0);
      } else {
        setCurrentStep(1);
      }
      return;
    }
    if (currentStep === 3) {
      setCurrentStep(2);
      return;
    }
    setCurrentStep(Math.min(0, currentStep - 1));
  };
  const progressStep = () => {
    if (currentStep === 0) {
      if (!name) {
        alert.show("Name is required");
        return;
      }
      if (!description) {
        alert.show("Description is required");
        return;
      }
      if (!currency) {
        alert.show("Please select currency");
        return;
      }
      if (cost === "") {
        alert.show("Please enter cost");
        return;
      }
      if (maxPeople === "") {
        alert.show("'Max number of people' is required");
        return;
      }
      if (expectedDuration === "" || !expectedDurationUnit) {
        alert.show("Expected duration is required");
        return;
      }
      // todo: need to validate this properly and prompt
      if (!is_visit && !category) {
        alert.show("Category is required");
        return;
      }
      if (location_flag && !addressLine1) {
        alert.show(
          "Location is checked : Office no - Floor - Building Name field is mandatory"
        );
        return;
      }
      if (location_flag && !area) {
        alert.show("Location is checked : Area field is mandatory");
        return;
      }
      if (location_flag && !state) {
        alert.show("Location is checked : State field is mandatory");
        return;
      }
      if (location_flag && !country) {
        alert.show("Location is checked : Country field is mandatory");
        return;
      }
      // if !traits.length => go to step 3
      if (traits.length === 0) {
        setCurrentStep(2);
      } else {
        setCurrentStep(1);
      }
      return;
    }
    if (currentStep === 1) {
      //todo:  validate
      // validate that all are completed
      setCurrentStep(2);
      return;
    }
    if (currentStep === 2) {
      //todo:  validate
      //save
      if (showStepFour) {
        setCurrentStep(3);
        return;
      }

      handleSubmit();
    }
    if (currentStep === 3) {
      //todo:  validate
      //save
      handleSubmit();
    }
  };

  const onSlotUpdate = (slot) => {
    // if valid slot && and _id is set -> update the slot
    // else insert new slot
    if (selectedSlotIndex === -1) {
      setSlots((slots) => [...slots, slot]);
    } else {
      const updatedSlots = [...slots];
      updatedSlots.splice(selectedSlotIndex, 1, slot);
      setSlots(updatedSlots);
    }
    setSelectedSlot(null);
    setSelectedSlotIndex(-1);
    setSlotModalActive(false);
  };

  const onSlotEdit = (id) => () => {
    setSelectedSlotIndex(id);
    setSelectedSlot(slots[id]);
    setSlotModalActive(true);
  };
  const onSlotDelete = (index) => () => {
    // todo: confirm
    const updatedSlots = slots.filter((slot, i) => i !== index);
    setSlots(updatedSlots);
  };

  const StepOne = () => {
    return (
      <>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12} md={7}>
              <Grid container spacing={1}>
                <Tooltip
                  title={
                    <span style={{ whiteSpace: "pre-line" }}>
                      {
                        "A Visit Activity is a time-unbounded activity, i.e. people can come and go any time during the visiting hours in order to participate (e.g. a dinner in a restaurant, an exhibition, or a walk at the beach).\nA Session Activity is a time-bounded activity, i.e. people have to come and leave at specific times to fully enjoy the activity (e.g. a cinema show, a concert, or a sports lesson)"
                      }
                    </span>
                  }
                  placement="top-start"
                >
                  <Grid item xs={4}>
                    <Autocomplete
                      fullWidth
                      options={[false, true]}
                      getOptionLabel={(option) =>
                        option === false ? "Session activity" : "Visit activity"
                      }
                      autoHighlight
                      disableClearable
                      value={is_visit}
                      onChange={(e, val) => {
                        setVisit(val);
                        if (val) {
                          setCategory(
                            providerCategoryList.find(
                              (category) =>
                                category._id === providerCategory?.id
                            ) || null
                          );
                        } else {
                          setCategory(
                            categoryList.find(
                              (category) =>
                                category._id === activity?.info?.category?.id
                            ) || null
                          );
                          setVisitingHours(false);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Type"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                </Tooltip>
                <Grid item xs={8}>
                  <TextField
                    fullWidth
                    label="Name *"
                    variant="outlined"
                    {...bindName}
                  />
                </Grid>
              </Grid>

              <div style={{ display: "flex" }}>
                <Autocomplete
                  options={currencies.sort()}
                  autoHighlight
                  disableClearable
                  value={currency}
                  onChange={(e, val) => setCurrency(val)}
                  style={{ width: 140, marginRight: 8 }}
                  renderOption={(option) => (
                    <Typography noWrap>{option}</Typography>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Currency *"
                      variant="outlined"
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "new-password", // disable autocomplete and autofill
                      }}
                    />
                  )}
                />
                <Tooltip
                  title={
                    <span style={{ whiteSpace: "pre-line" }}>
                      {"Average cost per person"}
                    </span>
                  }
                  placement="bottom-start"
                >
                  <TextField
                    label="Cost *"
                    variant="outlined"
                    type="number"
                    style={{ flex: "1" }}
                    {...bindCost}
                    InputProps={{ inputProps: { min: "-1" } }}
                    error={cost >= 0 ? false : true}
                    helperText={cost >= 0 ? "" : "Cannot be less than 0"}
                  />
                </Tooltip>
              </div>
            </Grid>
            <Tooltip
              title={
                <span style={{ whiteSpace: "pre-line" }}>
                  {"Please try to limit the description to 3 lines"}
                </span>
              }
              placement="bottom-start"
            >
              <Grid item xs={12} md={5}>
                <TextField
                  fullWidth
                  label="Description *"
                  multiline
                  rows={5}
                  className={classes.description}
                  variant="outlined"
                  {...bindDescription}
                />
              </Grid>
            </Tooltip>
            {/* <Grid xs={12} container spacing={1} style={{alignItems: 'center', justify: 'center', marginLeft:20, marginTop:3}}>
                             <Grid item>
                                <FormControlLabel
                                    label="Can people freely access the activity location during visiting hours?"
                                    control={<Checkbox checked={is_visit} 
                                    onChange={async (event)=>{
                                    setVisit(event.target.checked);
                                    if(event.target.checked){
                                        setCategory(providerCategory)
                                    }
                                    else{
                                        setCategory(categoryList.find(category => category._id === activity?.info?.category?.id) || null)
                                    }
                                    // console.log(walk_in)
                                    }} />}
                                />
                            </Grid>
                        </Grid> */}
            <Grid item xs={12}>
              <Autocomplete
                id="category"
                freeSolo
                // disabled = {is_visit}
                ListboxComponent={ListboxComponent}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    // timeout to avoid instant validation of the dialog's form.
                    setTimeout(() => {
                      handleCategoryRequest(newValue);
                      setCategory({ name: newValue });
                    });
                  } else if (newValue && newValue.inputValue) {
                    handleCategoryRequest(newValue.inputValue);
                    setCategory({ name: newValue.inputValue });
                  } else {
                    setCategory(newValue);
                  }
                }}
                value={category}
                options={is_visit ? providerCategoryList : categoryList}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  if (params.inputValue !== "") {
                    filtered.push({
                      inputValue: params.inputValue,
                      name: `Not found, Request "${params.inputValue}" to be added`,
                    });
                  }

                  return filtered;
                }}
                getOptionLabel={(option) => {
                  // e.g value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  return option.name || "";
                }}
                // renderOption={(option) => `.parent?.name && ' » ') || ''}${option.name}`}
                renderOption={(option) => {
                  return (
                    <React.Fragment>
                      {!!option?.vertical?.name &&
                        option?.vertical?.name !== option?.parent?.name && (
                          <Typography>
                            {option?.vertical?.name + " - "}
                          </Typography>
                        )}
                      {!!option?.parent?.name && (
                        <Typography>
                          {option.parent?.name === "Root"
                            ? ""
                            : option?.vertical?.name === option?.parent?.name
                            ? option.parent?.name + " - "
                            : "> " + option.parent?.name + " - "}
                        </Typography>
                      )}
                      {option?.name !== "Root" && (
                        <Typography
                          style={{ fontWeight: "bold", paddingRight: 8 }}
                        >
                          {" "}
                          {option.parent?.name === "Root"
                            ? option.name
                            : "> " + option.name}
                        </Typography>
                      )}
                    </React.Fragment>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Category *"
                    margin="normal"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            <Tooltip
              title={
                <span style={{ whiteSpace: "pre-line" }}>
                  {"Please add flags based on the type of activity."}
                </span>
              }
              placement="top-start"
            >
              <Grid item xs={12}>
                <Autocomplete
                  id="flags"
                  value={flags}
                  onChange={(event, newValue) => {
                    if (typeof newValue === "string") {
                      setFlags({
                        newValue,
                      });
                    } else {
                      setFlags(newValue);
                    }
                  }}
                  filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    // Suggest the creation of a new value
                    if (
                      params.inputValue !== "" &&
                      !options.includes(params.inputValue)
                    ) {
                      filtered.push(params.inputValue);
                    }

                    return filtered;
                  }}
                  multiple
                  options={flag_options}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option}
                  renderOption={(option, { selected }) => (
                    // console.log(option,selected),
                    <React.Fragment>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Flags"
                      // margin="dense"
                      variant="outlined"
                      placeholder="Select the flags based on the type of activity"
                    />
                  )}
                />
              </Grid>
            </Tooltip>
            <Tooltip
              title={
                <span style={{ whiteSpace: "pre-line" }}>
                  {
                    "Please enter 0 if the max cpacity is not specified or not applicable"
                  }
                </span>
              }
              placement="bottom-start"
            >
              <Grid item xs={12} md={6}>
                <TextField
                  label="Max number of people *"
                  fullWidth
                  type="number"
                  variant="outlined"
                  {...bindMaxPeople}
                  InputProps={{ inputProps: { min: "-1" } }}
                  error={maxPeople >= 0 ? false : true}
                  helperText={maxPeople >= 0 ? "" : "Cannot be less than 0"}
                />
              </Grid>
            </Tooltip>
            <Tooltip
              title={
                <span style={{ whiteSpace: "pre-line" }}>
                  {
                    "Please enter 0 if the estimated duration is not specified or not applicable"
                  }
                </span>
              }
              placement="bottom-start"
            >
              <Grid item xs={12} md={6}>
                <div style={{ display: "flex" }}>
                  <TextField
                    label="Estimated duration *"
                    variant="outlined"
                    InputProps={{ inputProps: { min: "-1" } }}
                    error={expectedDuration >= 0 ? false : true}
                    helperText={
                      expectedDuration >= 0 ? "" : "Cannot be less than 0"
                    }
                    {...bindExpectedDuration}
                    type="number"
                    style={{ flex: "1", marginRight: 8 }}
                  />
                  <Autocomplete
                    options={["seconds", "minutes", "hours", "days", "weeks"]}
                    autoHighlight
                    disableClearable
                    value={expectedDurationUnit}
                    onChange={(e, val) => setDurationUnit(val)}
                    style={{ width: 140, marginRight: 8 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Unit *"
                        variant="outlined"
                      />
                    )}
                  />
                </div>
              </Grid>
            </Tooltip>
            <Grid item xs={12}>
              <Grid item xs={12}>
                <Typography variant="h6" style={{ flex: "1" }}>
                  Slots
                </Typography>
              </Grid>
              {is_visit ? (
                <Grid item xs={12}>
                  <FormControlLabel
                    label="Are the visiting hours same as opening hours?"
                    disabled={slots.length > 0 || !is_visit}
                    control={
                      <Checkbox
                        checked={visiting_hours}
                        onChange={async (event) => {
                          setVisitingHours(event.target.checked);
                          // console.log(walk_in)
                        }}
                      />
                    }
                  />
                </Grid>
              ) : (
                <Grid item xs={12}></Grid>
              )}
              <Grid container spacing={1} justifyContent="flex-start">
                <Grid item>
                  <Button
                    style={{ minHeight: 100, maxHeight: 250 }}
                    variant="contained"
                    size="small"
                    color="primary"
                    disabled={visiting_hours}
                    onClick={() => {
                      setSelectedSlot(null);
                      setSlotModalActive(true);
                    }}
                  >
                    Add Slot
                  </Button>
                </Grid>
                <Grid item xs>
                  <Grid
                    container
                    style={{
                      minHeight: 100,
                      maxHeight: 250,
                      display: "flex",
                      overflowY: "scroll",
                    }}
                  >
                    <Grid item xs={12} className={classes.chipGroup}>
                      {slots?.length === 0 && (
                        <Typography
                          variant="subtitle1"
                          style={{ width: "100%", textAlign: "center" }}
                        >
                          {visiting_hours
                            ? "Visiting hours are set to opening hours of the branch"
                            : "No Slots available"}
                        </Typography>
                      )}
                      {slots?.map((slot, i) => (
                        <SlotCard
                          data={slot}
                          key={i}
                          onEdit={onSlotEdit(i)}
                          onDelete={onSlotDelete(i)}
                          label="hi"
                        />
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid item xs={12}>
                <Typography variant="h6">Location</Typography>
              </Grid>
              <Accordion expanded={expanded} onChange={handleExpand()}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  style={
                    location_flag
                      ? {
                          backgroundColor: "#0097a7",
                          color: "white",
                          height: 50,
                        }
                      : { height: 50 }
                  }
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Grid item xs={1} justifyContent="center">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={location_flag}
                          style={location_flag ? { color: "white" } : {}}
                          onChange={async (event) => {
                            setLocationFlag(event.target.checked);
                            onChangeLocationFlag(event.target.checked);
                            setExpanded(event.target.checked);
                            console.log(location);
                          }}
                        />
                      }
                    />
                  </Grid>
                  <Grid item xs alignItems="center" style={{ marginTop: 8 }}>
                    <Typography>
                      Is the location of the activity different from branch
                      address?
                    </Typography>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid item xs={12} md={6}>
                    <TextField
                      disabled={!location_flag}
                      fullWidth
                      label="Office No - Floor - Building Name *"
                      variant="outlined"
                      {...bindAddressLine1}
                    />
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <TextField
                          disabled={!location_flag}
                          fullWidth
                          label="Street No - Street Name"
                          variant="outlined"
                          {...bindStreet}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          disabled={!location_flag}
                          fullWidth
                          label="Landmark"
                          variant="outlined"
                          {...bindLandmark}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <TextField
                          disabled={!location_flag}
                          fullWidth
                          label="Area *"
                          variant="outlined"
                          {...bindArea}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          disabled={!location_flag}
                          fullWidth
                          label="City"
                          variant="outlined"
                          {...bindCity}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        {/* <TextField fullWidth label="State *" variant="outlined" {...bindState} /> */}
                        <Autocomplete
                          id="State"
                          fullWidth
                          disabled={!location_flag}
                          options={filterState}
                          classes={{ option: classes.option,}}
                          getOptionLabel={(option) => option.name}
                          autoHighlight
                          disableClearable
                          value={state}
                          onChange={(e, val) => setStateValue(val)}
                          renderOption={(option) => (
                            <Fragment>
                                {option.name}
                            </Fragment>
                            )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="State *"
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Autocomplete
                          disabled={!location_flag}
                          id="country-select"
                          options={countries}
                          classes={{
                            option: classes.option,
                          }}
                          autoHighlight
                          disableClearable
                          getOptionLabel={(option) => option.label}
                          value={country}
                          onChange={(e, option) => onCountryChange(option)}
                          renderOption={(option) => (
                            <Fragment>
                              <span>{countryToFlag(option.code)}</span>
                              {option.label} ({option.code})
                            </Fragment>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              label="Country *"
                              variant="outlined"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "new-password", // disable autocomplete and autofill
                              }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={6}>
                          <TextField fullWidth label="Postcode" variant="outlined" {...bindZipCode} />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={6}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <PlacePicker
                      disabled={!location_flag}
                      loading={mapLoading}
                      location={location}
                      onChange={setLocation}
                    />
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>
            <Grid item xs={12}>
              <Grid item xs={12}>
                <Typography variant="h6" style={{ flex: "1" }}>
                  Notes
                </Typography>
              </Grid>
              <Tooltip
                title={
                  <span style={{ whiteSpace: "pre-line" }}>
                    {
                      "Please use this field if there is any additional information from the provider"
                    }
                  </span>
                }
                placement="bottom-start"
              >
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={2}
                    label="Additional information"
                    variant="outlined"
                    {...bindNotes}
                  />
                </Grid>
              </Tooltip>
            </Grid>
          </Grid>
        </DialogContent>
      </>
    );
  };

  const StepFour = () => {
    if (!activity) return <></>;

    const checkboxHandler = (id) => {
      setSelectedBranches((prevIds) => {
        if (prevIds.includes(id)) return prevIds.filter((item) => item !== id);
        return [...prevIds, id];
      });
    };

    const handleSelectAll = (event) => {
      setSelectedBranches(templateBranches.flatMap((item) => item.isLinkedToActivity ? item._id : []));
    };
    const handleDeselectAll = () => {
      setSelectedBranches([]);
    };

    return (
      <>
        <DialogContent style={{ minHeight: "400px" }}>
          <Grid container spacing={5}>

            <Grid item xs={12}>
              <Typography variant="h6">
                Changes to be applied
              </Typography>
              <Grid container direction="column">
                {/* <FormControlLabel
                  label="Reset the data in branch activities to the template"
                  control={
                    <Checkbox
                      checked={isResetBranchData}
                      onChange={() => setResetBranchData(!isResetBranchData)}
                    />
                  }
                /> */}

                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="copyBelow"
                  name="radio-buttons-group"
                  onChange={handleRadioChange}
                >
                  <FormControlLabel value="copyAll" control={<Radio />} label="Copy all data from template activity to selected branch activities" />
                  <FormControlLabel value="copyBelow" control={<Radio />} label="Copy only the below changes from template activity to selected branch activities" />
                </RadioGroup>

                {(Object.values(changes).some((item) => item.show) ||
                  traitChanges.length > 0) && ( <Paper variant="outlined" elevation={3} style={{ padding: "1em" } }>

                    {Object.values(changes).map(({ label, show }) => (
                      <>
                        {show && ( 
                          <Grid item>
                            <Typography variant="h8" color= {isResetBranchData ? "textSecondary" : "initial" }style={{ padding: "1em" }} >{label}</Typography>
                          </Grid>
                        )}
                      </>
                    ))}
                    {traitChanges.map(({ label, show }) => (
                      <>
                        {show && (
                          <Grid item>
                            <Typography variant="h8">{label}</Typography>
                          </Grid>
                        )}
                      </>
                    ))}
                  </Paper>
                  )}
              </Grid>
            </Grid>


            <Grid item xs={12}>
              <div style={{ display: "flex", marginBottom: "10px" }}>
                <Typography variant="h6" style={{ marginRight: "10px" }}>
                  Linked branches
                </Typography>
                <ButtonGroup>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleSelectAll}
                  >
                    Select all
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleDeselectAll}
                  >
                    Clear all
                  </Button>
                </ButtonGroup>
              </div>
              <Paper variant="outlined"  elevation={3} style={{ padding: "1em" }}>

                <Grid container spacing={3} >
                  {templateBranches.map((item) => (
                    <Grid item>
                      {item.isLinkedToActivity ? (
                        <FormControlLabel
                        control={
                            <Checkbox
                              checked={selectedBranches.includes(item._id)}
                              onChange={() => checkboxHandler(item._id)}
                            />}
                          label={item.name}
                          />
                      ) : (
                        <Tooltip title="Branch has no activity associated with the template">
                           <FormControlLabel
                        control={
                          <Checkbox
                            labelPlacement="end"
                            checked={selectedBranches.includes(item._id)}
                            onChange={() => checkboxHandler(item._id)}
                            disabled
                          />}
                          label={item.name}
                          />
                        </Tooltip>
                      )}
                    </Grid>
                  ))}
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </DialogContent>
      </>
    );
  };

  const StepThree = () => {
    return (
      <>
        <DialogContent style={{ minHeight: "400px" }}>
          <Grid container spacing={1}>
            <UploadImages />
          </Grid>
        </DialogContent>
      </>
    );
  };
  const StepTwo = () => {
    return (
      <>
        <DialogContent>
          <Grid container spacing={2}>
            {/*
                            if CATEGORY not changed, display the currently saved traits in activity
                            if category changed, display the new traits
                        */}

            <Grid item xs={12}>
              <WidgetComponent traitGroups={traits} onChange={setTraits} />
            </Grid>
            <Tooltip
              title={
                <span style={{ whiteSpace: "pre-line" }}>
                  {
                    "Please use this field if there is any additional information from the provider"
                  }
                </span>
              }
              placement="bottom-start"
            >
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  rows={5}
                  label="Additional information"
                  variant="outlined"
                  {...bindTraitNotes}
                />
              </Grid>
            </Tooltip>
          </Grid>
        </DialogContent>
      </>
    );
  };

  const lastStep = showStepFour ? 3 : 2;

  return (
    <>
      <div
        style={{
          display: "flex",
          padding: "16px 24px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" style={{ flex: "1" }}>
          {isEditForm ? "Edit activity" : "Add activity"}
        </Typography>
        <IconButton onClick={onCancel}>
          <Close />
        </IconButton>
      </div>
      <Stepper activeStep={currentStep}>
        <Step>
          <StepLabel>Activity details</StepLabel>
        </Step>
        <Step>
          <StepLabel>Additional Questions</StepLabel>
        </Step>
        <Step>
          <StepLabel>Images</StepLabel>
        </Step>
        {showStepFour && (
          <Step>
            <StepLabel>Select Branches</StepLabel>
          </Step>
        )}
      </Stepper>
      <form className={classes.root} onSubmit={handleSubmit}>
        {currentStep === 0 && StepOne()}
        {currentStep === 1 && StepTwo()}
        {currentStep === 2 && StepThree()}
        {currentStep === 3 && StepFour()}
      </form>
      <DialogActions>
        <Grid container spacing={1} justify="flex-end" alignItems="flex-end">
          <Grid item>
            {currentStep === 3 && (
              <Button
                variant="contained"
                onClick={() => {
                  setSelectedBranches([]);
                }}
                style={{ marginRight: 8 }}
                disabled={selectedBranches.length === 0}
                color="secondary"
              >
                {"Clear"}
              </Button>
            )}
            {currentStep === 3 && (
              <Button
                variant="contained"
                onClick={() => {
                  setSelectedBranches(templateBranches.map((item) => item._id));
                }}
                style={{ marginRight: 8 }}
                color="secondary"
                disabled={selectedBranches.length === templateBranches.length}
              >
                {"Select all"}
              </Button>
            )}
            <Button
              variant="contained"
              disabled={currentStep <= 0 || loading}
              onClick={onPrevClick}
              style={{ marginRight: 8 }}
              color="secondary"
            >
              Prev
            </Button>
            <Button
              onClick={progressStep}
              disabled={loading}
              variant="contained"
              color="primary"
            >
              {loading && (
                <CircularProgress
                  color="inherit"
                  style={{ marginRight: 8 }}
                  size={20}
                />
              )}
              {currentStep === lastStep ? "Save" : "Next"}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
      <Dialog open={slotModalActive} maxWidth="xs" fullWidth>
        <AddSlotComponent
          data={selectedSlot}
          onUpdate={onSlotUpdate}
          onClose={() => setSlotModalActive(false)}
        />
      </Dialog>
      <RequestCategory
        dialogValue={dialogValue}
        setDialogValue={setDialogValue}
        user={user}
        providerId={providerId}
        categoryTree={is_visit ? providerCategoryTree : activityCategoryTree}
        open={requestDialogActive}
        handleRequest={onCategoryRequest}
        handleClose={handleRequestFormClose}
      />
    </>
  );
}
